import React, { useState } from "react";
import { AUTH_RESET_URL } from "../../../config";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Logo from "../../../assets/LOGO_bg.png";
import "./style.scss";
import swal from "sweetalert";
import Loader from "../../../components/Loader2";

const UpdatePassword = (props) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const update = async () => {
    let inp = document.getElementById("update_password");
    setIsLoading(true);
    try {
      await axios.post(AUTH_RESET_URL, {
        email: "mail here",
        token: "token",
        password: inp.value,
      });
      await swal("Success", "Password has been reset", "success");
      setIsLoading(false);
      history.push("/login");
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="update_password_container"
      style={{ height: window.innerHeight }}
    >
      <div className="update_password_box">
        {/* Logo */}
        <div className="logo">
          <img src={Logo} alt="bevoice" />
        </div>
        {/* Vertical Seperator */}
        <div className="vertical_seperator"></div>
        {/* Main form */}
        <div className="update_password_form">
          {/* Titles */}
          <div>
            <div className="title">Welcome to Bevoice!</div>
            <div className="subtitle">
              To enojoy our journey, please insert your e-mail and password.
            </div>
          </div>
          <input
            type="password"
            name="password"
            id="update_password"
            placeholder="Enter new password"
          />
          <input
            type="password"
            name="cpassword"
            id="update_cpassword"
            placeholder="Confirm new password"
          />
          <div className="update_password_buttons">
            {/* update & Login buttons */}
            <button id="login_btn" onClick={() => history.push("/login")}>
              Login
            </button>
            <button id="update_password_btn" onClick={() => update()}>
              {isLoading ? <Loader size="sm" color="#fff" /> : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
